// extracted by mini-css-extract-plugin
export default {"invalidMain":"Y4YalP","invalidText":"a3Q5Jq"};